<template>
	<div>
		<div class="bb-panel-wrapper b360-grid-row">
			<section class="b360-col-12">
				<span class="b360-form-label" role="heading">Your Licenses</span>
				<ul id="license-list" class="license-list" role="listbox">
					<li
						v-for="(license, index) in licenseList"
						:key="index"
						class="license-item"
						role="option"
						:id="`license-${index}`"
					>
						{{ license.licenseName }} - {{ license.state }}
						<toggle-switch
							@click="selectLicense(index)"
							:class="license.isSelected"
							v-model="licenseList[index].isSelected"
						></toggle-switch>
					</li>
				</ul>
			</section>

			<section class="b360-col-12">
				<label class="b360-form-label disclaimer-label" for="preview-content">
					Disclaimer Preview
					<FormLabelTooltip
						:tooltip="`Update the requested information in the [brackets] below to finalize your disclaimer.`"
					/>
				</label>
				<div class="preview-content--wrapper">
					<textarea
						:value="disclaimerText"
						@keypress.enter.prevent
						@input="setDisclaimerPreview"
						class="preview-content"
						name="preview-content"
						id="preview-content"
					></textarea>
				</div>
			</section>

			<section class="b360-col-12" v-if="isFhaOrThreePercent">
				<label class="b360-form-label" for="disclaimer-loan-amount">
					Disclaimer Loan Amount
				</label>
				<div>
					<div
						tabindex="0"
						class="radio-bar"
						:class="{
							isChecked: additionalDisclaimerloanAmount === 200000,
						}"
						@click="handleLoanAmount(200000, disclaimerTextLoanAmount200000)"
						role="button"
					>
						<span class="radio-bar-title">$200,000</span>
						<Radio
							radioId="loanamount-200000-0"
							radioGroupName="loanamount-200000-0"
							:isChecked="additionalDisclaimerloanAmount == 200000"
							radioDescription="loanamount-200000 media group radio"
						/>
					</div>
					<div
						tabindex="1"
						class="radio-bar"
						:class="{
							isChecked: additionalDisclaimerloanAmount === 400000,
						}"
						@click="handleLoanAmount(400000, disclaimerTextLoanAmount400000)"
						role="button"
					>
						<span class="radio-bar-title">$400,000</span>
						<Radio
							radioId="loanamount-400000-1"
							radioGroupName="loanamount-400000-1"
							:isChecked="additionalDisclaimerloanAmount == 400000"
							radioDescription="loanamount-400000 media group radio"
						/>
					</div>
				</div>
			</section>

			<section class="b360-col-12">
				<section class="image-columns b360-grid-row">
					<ComplianceLogos
						class="b360-col-12"
						:logoList="logoList"
						:disabledClass="
							$store.getters.roleIsNotActive('EditAComplianceLogo')
						"
						:selectedLogos="selectedLogoIds"
						@handle-click="selectLogo"
						:key="userId"
					></ComplianceLogos>
				</section>
			</section>
		</div>
		<button class="b360-btn b360-btn--workspace-primary" @click="nextStep()">
			Next Step
		</button>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import ToggleSwitch from '@/components/global/ToggleSwitch.vue';
import Radio from '@/components/global/Radio.vue';
import FormLabelTooltip from '@/components/global/FormLabelTooltip.vue';
import ComplianceLogos from '@/components/preference-center/ComplianceLogos.vue';
import campaignService from '@/services/toolbox/campaign-service';

export default {
	name: 'BbLegal',
	components: {
		ToggleSwitch,
		Radio,
		FormLabelTooltip,
		ComplianceLogos,
	},
	data() {
		return {
			additionalDisclaimerloanAmount: 200000,
			isFhaOrThreePercent:
				this.$route.params.campaignId === '1' ||
				this.$route.params.campaignId === '19',
			currentCampaignId: this.$route.params.campaignId,
			disclaimerTextLoanAmount200000: '',
			disclaimerTextLoanAmount400000: '',
		};
	},
	computed: mapState({
		// TODO: Determing if licenseKey can = 'string'
		licenseList: (state) => state.licenses.list,
		logoList: (state) => {
			if (
				!state.companyProfile.licenses.some(
					(license) =>
						license.licenseKey === 'MA' || license.licenseKey === 'string',
				) &&
				state.complianceLogos.logosList.some(
					(el) => el.title === 'complanceLogoType6',
				)
			) {
				return state.complianceLogos.logosList.slice(
					0,
					state.complianceLogos.logosList.length - 3,
				);
			}

			if (
				state.companyProfile.licenses.some(
					(license) =>
						license.licenseKey === 'MA' || license.licenseKey === 'string',
				) &&
				state.companyProfile.institutionType !== 'CreditUnion'
			) {
				return state.complianceLogos.logosList.slice(
					0,
					state.complianceLogos.logosList.length - 2,
				);
			}

			return state.complianceLogos.logosList;
		},
		getAllLicensesOn: (state) =>
			state.licenses.list.every((el) => el.isSelected === true),
		profile: (state) => state.profile,
		disclaimerText: (state) => {
			let text = '';
			const selectedItems = state.licenses.list.filter(
				(license) => license.isSelected === true,
			);
			selectedItems.forEach((el) => {
				text += `${el.disclaimerText}\n`;
			});
			return text.replace(/\n$/, '');
		},
		contactId: (state) => state.profile.contactId,
		selectedLogoIds: (state) =>
			state.complianceLogos.selectedLogos.map((el) => parseInt(el.value, 10)),
		selectedLogos: (state) =>
			state.complianceLogos.selectedLogos.map((el) => el),
		userId: (state) => state.profile.userId,
		selectedMediaType: (state) => state.brandBuilderEditor.selectedMediaType,
	}),
	methods: {
		...mapActions([
			'selectLicense',
			'selectLogo',
			'toggleAllLicenses',
			'setDisclaimerPreview',
			'completeVideoAction',
			'updateDisclaimers',
			'toggleSmPreview',
		]),
		toggleChildSwitch(toggleIndex, event) {
			if (!event.target.closest(`#${toggleIndex}`)) {
				document.getElementById(toggleIndex).click();
			}
		},
		selectCard(card) {
			this.selectLogo(card);
			// TODO: Refactor
			const checkBox = document.querySelector(`#image_${card.index}`);
			checkBox.checked = true;
		},
		handleLoanAmount(amount, additionalDisclaimerText) {
			this.additionalDisclaimerloanAmount = amount;
			const newDisclaimer = [
				{
					content: additionalDisclaimerText.disclaimer,
				},
			];
			this.updateDisclaimers(newDisclaimer);
		},
		nextStep() {
			/* flyer = 1, social = 2, email = 3, video = 4, ppt = 5, pricing flyer = 6 */
			const previewButton = document.querySelector('.bb-tool-sm-preview');
			let mobilePreviewDisplay = 'none';

			if (previewButton) {
				mobilePreviewDisplay = window.getComputedStyle(previewButton).display;
			}

			if (this.selectedMediaType === 4) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/preview`,
				});
			} else if (
				this.selectedMediaType !== 4 &&
				mobilePreviewDisplay !== 'none'
			) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/sm-preview`,
				});
				this.toggleSmPreview('on');
			} else if (this.selectedMediaType !== 4) {
				this.$router.push({
					path: `/campaign-editor-workspace/${this.$route.params.campaignId}/export`,
				});
			}
		},
		async setAdditionalDisclaimers() {
			if (this.currentCampaignId === '1' || this.currentCampaignId === '19') {
				this.disclaimerTextLoanAmount200000 =
					await campaignService.getCampaignDisclaimer(
						parseInt(this.currentCampaignId, 10),
						200000.0,
					);
				this.disclaimerTextLoanAmount400000 =
					await campaignService.getCampaignDisclaimer(
						parseInt(this.currentCampaignId, 10),
						400000.0,
					);
			}
		},
	},
	mounted() {
		this.completeVideoAction(null);
	},
	created() {
		this.setAdditionalDisclaimers();
	},
};
</script>

<style lang="scss" scoped>
.image-columns {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap;
	justify-content: space-between;

	.b360-grid-row {
		@include rem(margin-bottom, 15px);
	}
}

.image {
	background-size: contain;
}

.license {
	font-size: $b360-font-size--small;
	color: $subheader-color;
	line-height: 1;
	display: flex;
	flex-wrap: wrap;
	flex-direction: column;
	margin: 14px 0;
}

.title-name {
	@include typo--roboto__medium;
	padding-bottom: 3px;
}

.company-name {
	@include typo--roboto__regular;
}

.compliance-logo--wrapper {
	width: auto;
}

.radio-bar {
	@include rem(padding, 9px 15px);
	@include rem(margin, 0 15px 10px 0);
	display: inline-block;
	box-sizing: border-box;
	justify-content: space-between;
	border-radius: $b360-border-radius-base;
	box-shadow: inset 0 0 0 $b360-border-width-thin $border-color-light;
	background-color: $off-white;

	&:hover,
	&:focus,
	&.isChecked {
		box-shadow: inset 0 0 0 $b360-border-width-medium $brand-teal;

		.custom-radio {
			background-color: $brand-teal;
			box-shadow: inset 0 0 0 $b360-border-width-thin $brand-teal;
		}
	}

	&:hover {
		cursor: pointer;
	}

	.radio-bar-title {
		@include rem(margin-right, 75px);
	}
}

.disclaimer-label {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
</style>
